import styles from './Cite.module.css';

/**
 * Inline superscript citation marker. Pair with a Sources block at the
 * bottom of the same slide.
 */
export default function Cite({ n }: { n: number }) {
  return <sup className={styles.cite}>{n}</sup>;
}
